import breadcrumb from '@/components/breadcrumb' // 面包屑
import total from '@/components/total' // 总计

export default  {
	install(Vue){
		Vue.component('breadcrumb',breadcrumb)
		Vue.component('total',total)
	}
}